var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuUsersHoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/3 User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M17.8877 10.8967C19.2827 10.7007 20.3567 9.50473 20.3597 8.05573C20.3597 6.62773 19.3187 5.44373 17.9537 5.21973",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M19.7285 14.25C21.0795 14.452 22.0225 14.925 22.0225 15.9C22.0225 16.571 21.5785 17.007 20.8605 17.281",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8867 14.6641C8.67273 14.6641 5.92773 15.1511 5.92773 17.0961C5.92773 19.0401 8.65573 19.5411 11.8867 19.5411C15.1007 19.5411 17.8447 19.0591 17.8447 17.1131C17.8447 15.1671 15.1177 14.6641 11.8867 14.6641Z",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8867 11.888C13.9957 11.888 15.7057 10.179 15.7057 8.069C15.7057 5.96 13.9957 4.25 11.8867 4.25C9.77766 4.25 8.06766 5.96 8.06766 8.069C8.05966 10.171 9.75666 11.881 11.8587 11.888H11.8867Z",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M5.88472 10.8967C4.48872 10.7007 3.41572 9.50473 3.41272 8.05573C3.41272 6.62773 4.45372 5.44373 5.81872 5.21973",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M4.04388 14.25C2.69288 14.452 1.74988 14.925 1.74988 15.9C1.74988 16.571 2.19388 17.007 2.91188 17.281",
    stroke: "#3537E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUsersHoverIcon);
export default __webpack_public_path__ + "static/media/menu-users-hover-icon.8be45c411efa6ff8a3d73051930f9e48.svg";
export { ForwardRef as ReactComponent };